import React from 'react'
import ScribeGuide from './ScribeGuide'
import VideoGuide from './VideoGuide'

export default function ViewGuide(props) {
  const guideGuid = props.params.id
  const guides = JSON.parse(localStorage.getItem('guides')) || []
  const guide = guides.find(function(g) {
    return g.guid === guideGuid
  })

  const type = guide ? guide.type : ''

  if (type === 'SCRIBE') {
    return <ScribeGuide guide={guide} />
  }
  if (type === 'VIDEO') {
    return <VideoGuide guide={guide} />
  }
  return <p>Unknown guide type</p>
}
